import FaSpinner from 'react-icons/lib/fa/spinner';
import styled, { keyframes } from 'styled-components';

const getHeight = props => {
  if (props.iconSize === 'large') {
    return '6rem;'
  }
  return '1rem';
}

const spinning = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const LoadingIndicator = styled(FaSpinner)`
  animation: ${spinning} 2s linear infinite;
  height: ${props => getHeight(props)};
  width: ${props => getHeight(props)}; /* this is a square */
`;

export default LoadingIndicator;
